<section [formGroup]="formGroup"
         class="mat-typography">
    <h4 translate>settings_security_password_complexity</h4>
    <div class="mat-checkbox-container">
        <mat-checkbox matInput
                      formControlName="hasSpecialCharacter"
                      name="hasSpecialCharacter"
                      class="form-control"
                      data-cy="special-characters-checkbox">
            {{ 'settings_security_form_enforce_special_chars' | translate }}
        </mat-checkbox>
    </div>
    <div class="mat-checkbox-container">
        <mat-checkbox matInput
                      formControlName="hasLowerCase"
                      name="hasLowerCase"
                      class="form-control"
                      data-cy="lowercase-checkbox">
            {{ 'settings_security_form_enforce_lowercase_letters' | translate }}
        </mat-checkbox>
    </div>
    <div class="mat-checkbox-container">
        <mat-checkbox matInput
                      formControlName="hasUpperCase"
                      name="hasUpperCase"
                      class="form-control"
                      data-cy="uppercase-checkbox">
            {{ 'settings_security_form_enforce_uppercase_letters' | translate }}
        </mat-checkbox>
    </div>
    <div class="mat-checkbox-container">
        <mat-checkbox matInput
                      formControlName="hasDigits"
                      name="hasDigits"
                      class="form-control"
                      data-cy="digits-checkbox">
            {{ 'settings_security_form_enforce_digits' | translate }}
        </mat-checkbox>
    </div>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_security_form_min_length' | translate"
               matInput
               uiRestrictInput="^[0-9]+$"
               formControlName="length"
               name="length"
               min="6"
               max="14"
               class="form-control"
               data-cy="min-length" />
        <mat-hint *ngIf="!formGroup.get('length')!.pristine &&
            formGroup.get('length')!.hasError('range')"
                  [translateParams]="formGroup.get('length')!.getError('range')"
                  translate
                  class="errorMessage">
            settings_security_form_range_warning
        </mat-hint>
    </mat-form-field>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_security_form_expiration_days' | translate"
               matInput
               uiRestrictInput="^[0-9]+$"
               formControlName="defaultExpirationDays"
               name="defaultExpirationDays"
               min="0"
               max="120"
               class="form-control"
               data-cy="expiration-days" />
        <mat-hint *ngIf="!formGroup.get('defaultExpirationDays')!.pristine &&
                     formGroup.get('defaultExpirationDays')!.hasError('range')"
                  [translateParams]="formGroup.get('defaultExpirationDays')!.getError('range')"
                  translate
                  class="errorMessage">
            settings_security_form_range_warning
        </mat-hint>
    </mat-form-field>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_security_form_previous_use_limit' | translate"
               matInput
               uiRestrictInput="^[0-9]+$"
               formControlName="previousUseLimit"
               name="previousUseLimit"
               min="0"
               max="10"
               class="form-control"
               data-cy="previously-used-passwords" />
        <mat-hint *ngIf="!formGroup.get('previousUseLimit')!.pristine &&
                     formGroup.get('previousUseLimit')!.hasError('range')"
                  [translateParams]="formGroup.get('previousUseLimit')!.getError('range')"
                  translate
                  class="errorMessage">
            settings_security_form_range_warning
        </mat-hint>
    </mat-form-field>
    <div class="mat-checkbox-container">
        <mat-checkbox matInput
                      formControlName="shouldChangePasswordAfterFirstLogin"
                      name="shouldChangePasswordAfterFirstLogin"
                      class="form-control"
                      data-cy="change-password-on-first-login">
            {{ 'settings_security_account_password_should_change_password' | translate }}
        </mat-checkbox>
    </div>
    <h4 translate>settings_security_account_lockout</h4>
    <div class="mat-checkbox-container">
        <mat-checkbox matInput
                      formControlName="isEnabled"
                      name="isEnabled"
                      class="form-control"
                      data-cy="account-lockout-enabled">
            {{ 'settings_security_account_lockout_enabled' | translate }}
        </mat-checkbox>
    </div>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_security_form_lockout_seconds' | translate"
               matInput
               uiRestrictInput="^[0-9]+$"
               formControlName="defaultAccountLockoutSeconds"
               name="defaultAccountLockoutSeconds"
               min="1"
               class="form-control"
               data-cy="lockout-seconds" />
        <mat-hint *ngIf="!formGroup.get('defaultAccountLockoutSeconds')!.pristine &&
                   formGroup.get('defaultAccountLockoutSeconds')!.hasError('range')"
                  [translateParams]="formGroup.get('defaultAccountLockoutSeconds')!.getError('range')"
                  translate
                  class="errorMessage">
            settings_security_form_range_warning
        </mat-hint>
    </mat-form-field>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_security_form_max_attempts' | translate"
               matInput
               uiRestrictInput="^[0-9]+$"
               formControlName="maxAccessAttempts"
               name="maxAccessAttempts"
               min="2"
               max="10"
               class="form-control"
               data-cy="max-access-attempts" />
        <mat-hint *ngIf="!formGroup.get('maxAccessAttempts')!.pristine &&
                   formGroup.get('maxAccessAttempts')!.hasError('range')"
                  [translateParams]="formGroup.get('maxAccessAttempts')!.getError('range')"
                  translate
                  class="errorMessage">
            settings_security_form_range_warning
        </mat-hint>
    </mat-form-field>
    <h4 translate>settings_security_form_robot</h4>
    <mat-form-field>
        <input [readonly]="isReadOnly$ | async"
               [placeholder]="'settings_security_form_run_disconnected' | translate"
               matInput
               uiRestrictInput="^[0-9]+$"
               formControlName="runDisconnected"
               name="runDisconnected"
               class="form-control"
               data-cy="robot-disconnected-hours" />
        <mat-hint *ngIf="!formGroup.get('runDisconnected')!.pristine &&
                   formGroup.get('runDisconnected')!.hasError('range')"
                  [translateParams]="formGroup.get('runDisconnected')!.getError('range')"
                  translate
                  class="errorMessage">
            settings_security_form_range_warning
        </mat-hint>
    </mat-form-field>
</section>
